import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import type React from "react";
import { useTranslation } from "react-i18next"; // For t function
import { Button } from "@/components/ui/button";
import { ResponsiveDialog, ResponsiveDialogContent, ResponsiveDialogHeader, ResponsiveDialogTitle } from "@/components/ui/responsive-dialog";
import { useIsMobile } from "@/hooks/use-mobile";
import { cn } from "@/lib/utils";
import { getCurrentLanguageInClient, getValueFromTranslations } from "@/lib/utils.client";
import type { Exchange } from "./schema";
interface ExchangeModalProps {
  isOpen: boolean;
  onClose: () => void;
  exchange: Exchange;
  user?: {
    availablePoints: number;
  };
  onConfirmExchange?: () => void;
  isExchanging?: boolean;
  readonly?: boolean;
}
export const ExchangeModal: React.FC<ExchangeModalProps> = t0 => {
  const $ = _c(61);
  const {
    isOpen,
    onClose,
    exchange,
    user,
    onConfirmExchange,
    isExchanging,
    readonly: t1
  } = t0;
  const readonly = t1 === undefined ? false : t1;
  const {
    t
  } = useTranslation();
  const lang = getCurrentLanguageInClient();
  const isMobile = useIsMobile();
  const exchangeReward = exchange.grantRewards[0];
  const imageSrc = exchangeReward?.icon?.[0];
  const exchangeTitle = getValueFromTranslations(lang, exchange.name_trans || {});
  const rewardTitle = getValueFromTranslations(lang, exchangeReward?.name_trans || exchangeReward?.item_name || {});
  const pointCost = exchange.costRewards.find(_temp);
  const requiredPoints = pointCost?.quantity || 0;
  const pointsNeeded = user ? requiredPoints - (user.availablePoints ?? 0) : 0;
  const hasEnoughPoints = user ? (user.availablePoints ?? 0) >= requiredPoints : false;
  const descriptionHtml = getValueFromTranslations(lang, exchangeReward?.description_trans || {});
  let t2;
  if ($[0] !== exchangeReward?.releaseDescription_trans) {
    t2 = exchangeReward?.releaseDescription_trans || {};
    $[0] = exchangeReward?.releaseDescription_trans;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const releaseDescriptionHtml = getValueFromTranslations(lang, t2);
  let t3;
  if ($[2] !== readonly || $[3] !== t || $[4] !== user) {
    t3 = !readonly && user ? <div className={cn(" text-center font-['DINPro-Regular'] font-normal text-[#666] not-italic", "mt-2 md:mt-4", "text-[0.625rem] md:text-base", "leading-[1.125rem] md:leading-5")}>{t("exchange_modal.available_points_label", "Available Points")}<span className={cn("font-['DINPro-Medium'] font-medium text-black text-center not-italic", "text-[0.625rem] md:text-base", "leading-[1.125rem] md:leading-5")}>{user.availablePoints}{t("exchange_modal.points_unit", " Points")}</span></div> : null;
    $[2] = readonly;
    $[3] = t;
    $[4] = user;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const userPointsInfo = t3;
  const T0 = ResponsiveDialog;
  let t4;
  if ($[6] !== onClose) {
    t4 = open => {
      if (!open) {
        onClose();
      }
    };
    $[6] = onClose;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const T1 = ResponsiveDialogContent;
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = cn("h-auto max-h-[60dvh] md:max-h-unset flex flex-col md:h-auto md:w-[626px] md:max-w-[626px] md:px-12 md:pb-12");
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = cn("text-left max-w-[18.75rem] md:max-w-[unset]");
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== exchangeTitle) {
    t7 = <ResponsiveDialogHeader className="pt-6 md:pt-12"><ResponsiveDialogTitle className={t6}>{exchangeTitle}</ResponsiveDialogTitle></ResponsiveDialogHeader>;
    $[10] = exchangeTitle;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const t8 = "flex-1 flex flex-col items-stretch min-height-0  overflow-y-auto";
  const t9 = "flex-1  min-height-0 overflow-x-hidden overflow-y-auto";
  let t10;
  let t11;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = cn("flex   items-center  ", "flex-col space-y-3 md:flex-row md:space-y-0  ");
    t11 = cn("relative flex items-center justify-center overflow-hidden ", "flex-shrink-0", "h-[7.5rem] w-[7.5rem] md:h-40 md:w-40");
    $[12] = t10;
    $[13] = t11;
  } else {
    t10 = $[12];
    t11 = $[13];
  }
  const t12 = imageSrc || "";
  let t13;
  if ($[14] !== rewardTitle || $[15] !== t12) {
    t13 = <div className={t11}><Image src={t12} alt={rewardTitle} fill={true} className="rounded object-contain" /></div>;
    $[14] = rewardTitle;
    $[15] = t12;
    $[16] = t13;
  } else {
    t13 = $[16];
  }
  let t14;
  let t15;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = cn("flex items-center text-center md:items-start md:text-left", "flex-col mb-3 md:mb-0 md:ml-5 md:h-auto");
    t15 = cn("font-['DINPro-Medium'] font-medium text-black not-italic line-clamp-2 overflow-hidden text-ellipsis", "max-h-12 w-full md:w-[21.875rem]", "text-base md:text-lg", "leading-5 md:leading-6");
    $[17] = t14;
    $[18] = t15;
  } else {
    t14 = $[17];
    t15 = $[18];
  }
  let t16;
  if ($[19] !== rewardTitle) {
    t16 = <h3 className={t15}>{rewardTitle}</h3>;
    $[19] = rewardTitle;
    $[20] = t16;
  } else {
    t16 = $[20];
  }
  const t17 = !readonly && requiredPoints > 0 ? <p className={cn("font-['DINPro-Medium'] font-medium text-[#aa8052] not-italic", "mt-2 md:mt-3", "text-lg md:text-xl", "h-[1.125rem] md:h-5", "leading-[1.125rem] md:leading-5")}>{t("exchange_modal.points_cost_format", {
      count: requiredPoints,
      defaultValue: "{{count}} Points"
    })}</p> : null;
  const t18 = isMobile && userPointsInfo;
  let t19;
  if ($[21] !== t14 || $[22] !== t16 || $[23] !== t17 || $[24] !== t18) {
    t19 = <div className={t14}>{t16}{t17}{t18}</div>;
    $[21] = t14;
    $[22] = t16;
    $[23] = t17;
    $[24] = t18;
    $[25] = t19;
  } else {
    t19 = $[25];
  }
  let t20;
  if ($[26] !== t10 || $[27] !== t13 || $[28] !== t19) {
    t20 = <div className={t10}>{t13}{t19}</div>;
    $[26] = t10;
    $[27] = t13;
    $[28] = t19;
    $[29] = t20;
  } else {
    t20 = $[29];
  }
  let t21;
  if ($[30] !== descriptionHtml) {
    t21 = descriptionHtml && <div className={cn(" rounded-md bg-[#f5f5f5] text-primary  break-words ", "mt-3 md:mt-4", "p-3 md:p-5", "text-xs md:text-sm")}><div className="rich-text-content" dangerouslySetInnerHTML={{
        __html: descriptionHtml
      }} /></div>;
    $[30] = descriptionHtml;
    $[31] = t21;
  } else {
    t21 = $[31];
  }
  const t22 = !isMobile && userPointsInfo;
  let t23;
  if ($[32] !== readonly || $[33] !== releaseDescriptionHtml) {
    t23 = readonly && releaseDescriptionHtml && <div className={cn("w-full text-primary", "mt-3 md:mt-4", "text-xs md:text-sm")}><div dangerouslySetInnerHTML={{
        __html: releaseDescriptionHtml
      }} /></div>;
    $[32] = readonly;
    $[33] = releaseDescriptionHtml;
    $[34] = t23;
  } else {
    t23 = $[34];
  }
  let t24;
  if ($[35] !== t20 || $[36] !== t21 || $[37] !== t22 || $[38] !== t23) {
    t24 = <div className={t9}>{t20}{t21}{t22}{t23}</div>;
    $[35] = t20;
    $[36] = t21;
    $[37] = t22;
    $[38] = t23;
    $[39] = t24;
  } else {
    t24 = $[39];
  }
  let t25;
  if ($[40] !== hasEnoughPoints || $[41] !== isExchanging || $[42] !== onConfirmExchange || $[43] !== pointsNeeded || $[44] !== readonly || $[45] !== t || $[46] !== user) {
    t25 = !readonly && user && <div className={cn("mt-3 md:mt-4")}>{hasEnoughPoints ? <Button className={cn("w-full", "h-10 md:h-11", "text-sm md:text-base")} onClick={onConfirmExchange} loading={isExchanging}>{isExchanging ? t("exchange_modal.exchanging_button_text", "Exchanging...") : t("exchange_modal.exchange_now_button_text", "Exchange Now")}</Button> : <Button disabled={true} className={cn("w-full", "disabled:bg-[#eee]", "disabled:text-[#999]", "h-10 md:h-11", "text-sm md:text-base")}>{t("exchange_modal.points_needed_message_prefix", "You are still ")}<span className="font-semibold">{pointsNeeded}</span>{t("exchange_modal.points_needed_message_suffix", " Points away from this reward")}</Button>}</div>;
    $[40] = hasEnoughPoints;
    $[41] = isExchanging;
    $[42] = onConfirmExchange;
    $[43] = pointsNeeded;
    $[44] = readonly;
    $[45] = t;
    $[46] = user;
    $[47] = t25;
  } else {
    t25 = $[47];
  }
  let t26;
  if ($[48] !== t24 || $[49] !== t25) {
    t26 = <div className={t8}>{t24}{t25}</div>;
    $[48] = t24;
    $[49] = t25;
    $[50] = t26;
  } else {
    t26 = $[50];
  }
  let t27;
  if ($[51] !== T1 || $[52] !== t26 || $[53] !== t5 || $[54] !== t7) {
    t27 = <T1 className={t5}>{t7}{t26}</T1>;
    $[51] = T1;
    $[52] = t26;
    $[53] = t5;
    $[54] = t7;
    $[55] = t27;
  } else {
    t27 = $[55];
  }
  let t28;
  if ($[56] !== T0 || $[57] !== isOpen || $[58] !== t27 || $[59] !== t4) {
    t28 = <T0 open={isOpen} onOpenChange={t4}>{t27}</T0>;
    $[56] = T0;
    $[57] = isOpen;
    $[58] = t27;
    $[59] = t4;
    $[60] = t28;
  } else {
    t28 = $[60];
  }
  return t28;
};
function _temp(r) {
  return r.rewardType === "point";
}